import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import { surveyPlugin } from 'survey-vue3-ui'
import VueDaumPostcode from 'vue-daum-postcode'
import { createHead } from '@vueuse/head';

import { base64ToBlob, downloadBase64, fileToBase64, uploadBase64, uploadFile, downloadFile } from './plugins/filemanager'
import { docInfo, downloadPDF, sessionCheck, login, tokenLoad, searchCorpName } from './plugins/apimanager'
import { formatPhoneNo, formatRegNo, hideRegNo } from './plugins/apimanager'

import 'vue-fullpage.js/dist/style.css'
// import './fullpage.scrollHorizontally.min' // Optional. When using fullpage extensions
import VueFullPage from 'vue-fullpage.js'
import VueGtag from 'vue-gtag-next';

loadFonts()

const head = createHead();

createApp(App)
  .use(router)
  .use(store)
  .use(vuetify)
  .use(VueDaumPostcode)
  .use(surveyPlugin)
  .use(head)
  .use(VueFullPage)
  .mixin({
    methods: {
      base64ToBlob,
      fileToBase64,
      docInfo,
      downloadPDF,
      sessionCheck,
      login,
      tokenLoad,
      searchCorpName,
      uploadBase64,
      uploadFile,
      downloadFile,
      downloadBase64,
      formatPhoneNo,
      formatRegNo,
      hideRegNo
    }
  })
  // .use(VueGtag, {
  //   config: { id: "G-GWGQ3L17MD" }
  // })
  .use(VueGtag, {
    property: { id: "G-GWGQ3L17MD" },
    params: {
      // user_id: "12345",
      send_page_view: false,
      // linker: {
      //   domain: ['example.com']
      // }
    }
  })
  .mount('#app')



// app.use(VueDaumPostcode, {
//   scriptUrl: "https://s3.ap-northeast-2.amazonaws.com/YOUR_BUCKET_NAME/postcode.v2.js"
// })